import { AxiosError } from 'axios';
import MerchantCategory from '../../domain/entities/MerchantCategory';
import {
  MerchantCategoriesApi,
  newMerchantsCategoryApi,
} from '../api/backend/api';

interface SearchQuery {
  merchantCategoryIds?: number[];
  query?: string;
}

export class MerchantCategoryRepository {
  private api: MerchantCategoriesApi;

  constructor(api: MerchantCategoriesApi) {
    this.api = api;
  }

  public async Search(query: SearchQuery = {}): Promise<MerchantCategory[]> {
    return this.api
      .merchantCategoriesList(query.query, query.merchantCategoryIds)
      .then(res => {
        return res.data.merchantCategories.map(
          cat => new MerchantCategory(cat),
        );
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }

  public async Find(categoryId: number): Promise<MerchantCategory> {
    return this.api
      .merchantCategoriesFind(categoryId)
      .then(res => {
        return new MerchantCategory(res.data.merchantCategory);
      })
      .catch((err: AxiosError) => {
        // TODO handle error by status
        return Promise.reject(err);
      })
      .catch((err: Error) => {
        return Promise.reject(err);
      });
  }
}

export default new MerchantCategoryRepository(newMerchantsCategoryApi());
